// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__SbsE+jusrUsiU","head":"head__xu+J8rcqAc4Ek","title":"title__-Gnd7KFhzb4Cm","desc":"desc__uadzMLgMA+hoN"};